import React, { useState, useEffect } from 'react';
import { Shield, Radio, Wifi, X, LogOut, KeyRound } from 'lucide-react';
import C from '../../constants/colors';
import ChangePasswordModal from '../modals/ChangePasswordModal';

export default function TopBar({ activeEvents, sites, user, onLogout, onEndEvent }) {
  const [showChangePwd, setShowChangePwd] = useState(false);
  const [time, setTime] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const activeList = Object.values(activeEvents || {});

  return (
    <div style={{
      height: '52px', background: C.surface, borderBottom: `1px solid ${C.border}`,
      display: 'flex', alignItems: 'center', padding: '0 20px', gap: '16px',
      position: 'sticky', top: 0, zIndex: 100, flexShrink: 0,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <Shield size={20} color={C.red} />
        <span style={{ fontSize: '16px', fontWeight: 700, color: C.textPrimary, letterSpacing: '-0.02em' }}>
          Safe<span style={{ color: C.red }}>Check</span>
        </span>
      </div>

      <div style={{ flex: 1, display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
        {activeList.map(ev => {
          const site = sites.find(s => s.id === ev.siteId);
          const colors = { FIRE: C.orange, LOCKDOWN: C.purple, EVACUATION: C.red, MEDICAL: C.pink, DRILL: C.blue, OTHER: C.amber };
          const col = colors[ev.eventType] || C.amber;
          return (
            <div key={ev.id} style={{
              display: 'flex', alignItems: 'center', gap: '6px',
              background: col + '22', border: `1px solid ${col}44`,
              borderRadius: '6px', padding: '3px 6px 3px 10px',
              animation: 'alertPulse 2s infinite',
            }}>
              <Radio size={10} color={col} />
              <span style={{ fontSize: '11px', fontWeight: 600, color: col }}>
                {ev.eventType} — {site?.name || ev.siteId}
              </span>
              {onEndEvent && (
                <button
                  onClick={() => onEndEvent(ev.siteId)}
                  title="End Event"
                  style={{
                    marginLeft: '4px', background: col + '33', border: `1px solid ${col}55`,
                    borderRadius: '4px', cursor: 'pointer', color: col,
                    display: 'flex', alignItems: 'center', padding: '1px 4px',
                    fontSize: '10px', fontWeight: 700, fontFamily: 'inherit', gap: '3px',
                  }}
                >
                  <X size={9} />
                  Stop
                </button>
              )}
            </div>
          );
        })}
      </div>

      <div style={{
        fontFamily: 'JetBrains Mono, monospace', fontSize: '13px',
        color: C.textSecondary, letterSpacing: '0.05em',
      }}>
        {time.toLocaleTimeString('en-US', { hour12: false })}
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
        <Wifi size={14} color={C.green} />
        <span style={{ fontSize: '11px', color: C.green }}>Live</span>
      </div>

      {user && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', paddingLeft: '8px', borderLeft: `1px solid ${C.border}` }}>
          <span style={{ fontSize: '12px', color: C.textSecondary, maxWidth: '130px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {user.name || user.email}
          </span>
          <button
            onClick={() => setShowChangePwd(true)}
            title="Change password"
            style={{
              display: 'flex', alignItems: 'center', gap: '4px',
              padding: '5px 9px', borderRadius: '6px',
              border: `1px solid ${C.border}`, background: 'transparent',
              color: C.textMuted, fontSize: '12px', fontWeight: 500, cursor: 'pointer',
              fontFamily: 'inherit',
            }}
          >
            <KeyRound size={11} />
            Password
          </button>
          <button
            onClick={onLogout}
            title="Sign out"
            style={{
              display: 'flex', alignItems: 'center', gap: '4px',
              padding: '5px 9px', borderRadius: '6px',
              border: `1px solid ${C.border}`, background: 'transparent',
              color: C.textMuted, fontSize: '12px', fontWeight: 500, cursor: 'pointer',
              fontFamily: 'inherit',
            }}
          >
            <LogOut size={11} />
            Sign out
          </button>
        </div>
      )}

      {showChangePwd && <ChangePasswordModal onClose={() => setShowChangePwd(false)} />}
    </div>
  );
}
